import { useLocation, Outlet } from 'react-router';
import {
    LayoutGrid01,
    Users01,
    Settings01,
    File01,
    HelpCircle,
    Link01,
    BookOpen01
} from '@untitledui/icons';
import { SidebarNavigationSimple } from '@/components/application/app-navigation/sidebar-navigation/sidebar-simple';
import { HeaderNavigationBase } from '@/components/application/app-navigation/header-navigation';
import type { NavItemType } from '@/components/application/app-navigation/config';
import { useTranslation } from 'react-i18next';

export const AdminLayout = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const { t } = useTranslation('navigation');

    // Navigation items for sidebar
    const sidebarItems: NavItemType[] = [
        {
            label: t('dashboard'),
            href: '/admin/dashboard',
            icon: LayoutGrid01
        },
        {
            label: t('accounts'),
            href: '/admin/accounts',
            icon: Users01
        },
        {
            label: t('documents'),
            href: '/admin/documents',
            icon: File01
        },
        {
            label: t('workflows'),
            href: '/admin/workflows',
            icon: Link01
        },
        {
            label: t('knowledgeBase'),
            href: '/admin/knowledge',
            icon: BookOpen01
        },
        {
            label: t('settings'),
            href: '/admin/settings',
            icon: Settings01
        }
    ];

    // Header navigation items
    const headerItems = [
        {
            label: t('dashboard'),
            href: '/admin/dashboard',
            icon: LayoutGrid01
        },
        {
            label: t('accounts'),
            href: '/admin/accounts',
            icon: Users01
        },
        {
            label: t('documents'),
            href: '/admin/documents',
            icon: File01
        },
        {
            label: t('workflows'),
            href: '/admin/workflows',
            icon: Link01
        },
        {
            label: t('knowledgeBase'),
            href: '/admin/knowledge',
            icon: BookOpen01
        },
        {
            label: t('settings'),
            href: '/admin/settings',
            icon: Settings01
        }
    ];

    // Footer items for sidebar
    const footerItems: NavItemType[] = [
        {
            label: t('support'),
            href: '#',
            icon: HelpCircle
        },
    ];

    const env = import.meta.env.VITE_ENV;
    const hasEnvironmentBanner = env !== "production";

    return (
        <div className={`flex h-screen bg-secondary ${hasEnvironmentBanner ? "pt-7" : ""}`}>
            {/* Sidebar Navigation */}
            <SidebarNavigationSimple
                activeUrl={currentPath}
                items={sidebarItems}
                footerItems={footerItems}
                showAccountCard={true}
                className="hidden lg:flex"
            />

            {/* Main Content */}
            <div className="flex flex-1 flex-col overflow-hidden">
                {/* Header Navigation */}
                <HeaderNavigationBase
                    activeUrl={currentPath}
                    items={headerItems}
                    showAvatarDropdown={true}
                />

                {/* Page Content */}
                <main className="flex-1 overflow-auto bg-secondary">
                    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};
